
<header-report-component [grandAmount]="grandAmount" [transactionAmount]="transactionAmount" [merchantDetails]="merchantDetails"
                         [startDate]="StartDate" [endDate]="EndDate">
</header-report-component>

<table class="table table-striped" style="width: 100%" *ngFor="let group of groupedTerminals">
  <thead>
    <tr style="background-color: #4fbde9; color: white">
      <th>Post Trans Id</th>
      <th>Card Number</th>
      <th>Date</th>
      <th>Transaction Type</th>
      <th>Card Type</th>
      <th>Terminal</th>
      <th>RRN</th>
      <th style="text-align:right;">Amount</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of group.items">
      <td>{{ item.postTranId }}</td>
      <td>{{ item.pan }}</td>
      <td>{{ item.datetimeReq }}</td>
      <td>{{ item.tranType }}</td>
      <td>{{ item.totalsGroup }}</td>
      <td>{{ item.terminalId }}</td>
      <td>{{ item.retrievalReferenceNr }}</td>
      <td style="text-align:right;">R {{ convertToDecimal(item.amountAvailable) }}</td>
    </tr>
  </tbody>
  <tbody>
    <tr>
      <td colspan="8" style="padding-left:0px;">
        <div style="display: flex; gap: 10px;">
          <table class="table table-striped" style="width: 33%">
            <thead>
              <tr style="background-color: #348cd4; color: white">
                <th>Card Type</th>
                <th style="text-align:right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let totalGroup of getTerminalTotalGroups(group.terminalId)">
                <td>{{ totalGroup.totalsGroup }}</td>
                <td style="text-align:right">R {{ convertToDecimal(totalGroup.amount) }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-striped" style="width: 33%">
            <thead>
              <tr style="background-color: #348cd4; color: white">
                <th>Terminal</th>
                <th style="text-align:right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ group.terminalId }}</td>
                <td style="text-align:right">R {{ convertToDecimal(group.amountAvailable) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<table class="table table-striped" style="width: 50%" *ngIf="transactionReport?.length > 0">
  <thead>
    <tr style="background-color:silver; color: black">
      <th colspan="2">Grand Total</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td colspan="2">R {{ grandAmount }}</td>
    </tr>
  </tbody>
</table>

